<template>
    <div class="sb_page_idle">

        <svg v-anime="animations['logo']" id="pgf_logo" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="420.14" height="237.01" viewBox="0 0 420.14 237.01">
            <title>logo</title>
            <path id="logo_p" d="M109.16,201.55c-3.39.12-7.71,0.07-10.84,0l4.92-34.67c2.88-.28,6.7-0.51,10.91-0.66,13.32-.47,20.54,2.13,20.86,11.33a20.34,20.34,0,0,1-.26,4.16l-0.25,1.67c-1.77,12.32-10,17.66-25.35,18.2m5.55-39.25c-4.31.15-10.12,0.66-13.61,1a2.53,2.53,0,0,0-1.92,2l-10.1,70v0.4a1.38,1.38,0,0,0,1.46,1.43l1,0a2.21,2.21,0,0,0,1.92-2l4.3-29.69c2.81,0.1,7.21.15,11.12,0,17.36-.61,27.78-6.61,30-22.21l0.25-1.67a20.21,20.21,0,0,0,.24-4.16c-0.38-10.76-9.46-15.6-24.7-15.07" transform="translate(-89.07 -80.97)" />
            <path id="logo_r" d="M162,197.32c-2.88.1-10.52,0.27-13.22,0.36l4.6-32.17c3.1-.41,8.71-0.71,12.93-0.85,13.63-.48,20.61,1.95,20.92,10.75a25.59,25.59,0,0,1-.33,4.57l-0.09.48c-2.06,12.63-9.27,16.33-24.81,16.87m4.95-36.84c-4.31.15-12.22,0.63-15.73,1a2.57,2.57,0,0,0-1.92,2l-10.1,70.11v0.3a1.43,1.43,0,0,0,1.46,1.53l1,0a2.23,2.23,0,0,0,2-2l4.52-31.49s9-.21,12.92-0.35l4.62-.16L182.39,233a2.06,2.06,0,0,0,1.54.85l1,0a1.56,1.56,0,0,0,1.63-1.74,2.86,2.86,0,0,0-.32-1.17L170.43,200.7c11.49-1.79,18.63-7.37,20.78-20.41l0.09-.48a30.58,30.58,0,0,0,.32-4.87c-0.37-10.46-9-15-24.68-14.46" transform="translate(-89.07 -80.97)" />
            <path id="logo_o" d="M219,229c-10.44.36-17.51-3.82-18-17a55.57,55.57,0,0,1,.59-9.41l1.77-12.32c3-20.54,12.89-27.43,25.12-27.86,10.13-.35,17.48,3.64,17.95,17.06a54,54,0,0,1-.57,9.31l-1.77,12.32C241.27,220.65,231.43,228.59,219,229m10.18-70.72c-15,.52-26.81,8.66-30.21,32.19l-1.77,12.32a51.64,51.64,0,0,0-.57,9.23c0.53,15.18,9.37,21.59,21.8,21.16,14.93-.52,26.78-9.42,30.1-32.18l1.77-12.32a52.52,52.52,0,0,0,.58-9.11c-0.52-15-9.19-21.72-21.7-21.29" transform="translate(-89.07 -80.97)" />
            <path id="logo_f" d="M291.13,155.66c-13.43.47-26.09,3.08-28.88,23.23l-7.18,50.46v0.4a1.53,1.53,0,0,0,1.66,1.53l16.33-.57a2.55,2.55,0,0,0,2.33-2.07l4-27.59,24.66-.86a2.46,2.46,0,0,0,2.23-2.07L308,186.41v-0.3a1.64,1.64,0,0,0-1.77-1.62l-24.66.86,1.05-7.16c0.56-3.77,1.92-5,5.55-5.13l20.24-.71a2.43,2.43,0,0,0,2.23-2.07l1.8-12.12v-0.38a1.6,1.6,0,0,0-1.77-1.52,133.89,133.89,0,0,0-19.49-.6" transform="translate(-89.07 -80.97)" />
            <path id="logo_i" d="M341,154.9l-16.44.57a2.39,2.39,0,0,0-2.26,2l-10,69.91v0.4a1.53,1.53,0,0,0,1.66,1.53l16.44-.57a2.6,2.6,0,0,0,2.36-2.07l10-69.91v-0.3A1.54,1.54,0,0,0,341,154.9" transform="translate(-89.07 -80.97)" />
            <path id="logo_t" d="M402.53,152.76L352,154.52a2.39,2.39,0,0,0-2.26,2l-1.86,12.7v0.3a1.56,1.56,0,0,0,1.77,1.52l15.24-.53L357,225.79v0.4a1.52,1.52,0,0,0,1.66,1.53l16.33-.57a2.57,2.57,0,0,0,2.33-2.07l7.91-55.31,14.93-.52a2.45,2.45,0,0,0,2.33-2l1.88-12.7v-0.3a1.71,1.71,0,0,0-1.87-1.52" transform="translate(-89.07 -80.97)" />
            <path id="logo_g" d="M414.44,220.39c-5.51.19-9.08-4.74-9.29-10.7-0.28-8,4.86-15.24,11.9-15.49a9.42,9.42,0,0,1,8.05,3.77l-2,18.57a13,13,0,0,1-8.66,3.85m2.59-29c-8.52.3-15.29,8.66-14.93,18.74,0.26,7.47,4.86,13.22,12.11,13,4.65-.16,7.92-2.31,8.61-3.12l-0.15,1.57c-1.18,10.16-6,12.34-9.94,12.48s-6.89-2.63-8-3.77a1.35,1.35,0,0,0-1-.52,1,1,0,0,0-.72.38l-0.59.6a1,1,0,0,0,0,1.51c1,1,4.95,4.81,10.2,4.63,6-.21,11.79-4,13-15.6l2.94-28.62a0.79,0.79,0,0,0-.77-1l-0.54,0a0.93,0.93,0,0,0-1,.89l-0.59,2a11.21,11.21,0,0,0-8.62-3.22" transform="translate(-89.07 -80.97)" />
            <path id="logo_y" d="M462.34,190.45l-1.58.06a1.16,1.16,0,0,0-1,.74l-13,26.38h-0.13L439.21,192a0.84,0.84,0,0,0-.89-0.67l-1.38,0a0.84,0.84,0,0,0-.7,1.26l8.66,28.56-7.4,15c-0.31.67,0,1.06,0.55,1l1.4,0a1.24,1.24,0,0,0,1-.69l22.33-44.8c0.39-.67.11-1.24-0.5-1.22" transform="translate(-89.07 -80.97)" />
            <path id="logo_m" d="M500.62,188.46c-5.59.2-8.79,3.7-10.47,5.4-1.3-2.9-3.37-4.92-7.55-4.77a13.49,13.49,0,0,0-9.49,4.79l0-3a0.67,0.67,0,0,0-.74-0.75l-0.69,0a1,1,0,0,0-1,1l-3,28.44a0.75,0.75,0,0,0,.77,1l1.12,0a1,1,0,0,0,1-1L473,197.55a11.24,11.24,0,0,1,9.13-5.63c4.85-.17,6.59,3.44,5.83,10.47l-1.77,16.55a0.76,0.76,0,0,0,.85,1l1,0a1.3,1.3,0,0,0,1.11-1l1.67-16.54a18.71,18.71,0,0,0-.07-5.56c1.15-1.47,4.08-5.25,9.34-5.43s6.66,3.44,5.89,10.46l-1.75,16.54a0.74,0.74,0,0,0,.77,1l1.12,0a1.19,1.19,0,0,0,1.09-1l1.7-16.54c0.92-8-1.21-13.45-8.38-13.2" transform="translate(-89.07 -80.97)" />
            <path id="logo_curve-top" d="M413.67,81a132.06,132.06,0,0,1,36.95,83.24l10.87-.38A132.93,132.93,0,0,0,413.67,81" transform="translate(-89.07 -80.97)" />
            <path id="logo_curve-bottom" d="M439.59,259.22l-21.34.75A137.25,137.25,0,0,1,228.7,276.33a137.06,137.06,0,0,0,210.89-17.1" transform="translate(-89.07 -80.97)" />
        </svg>

        <dev-navigator v-if="showDevNavigator" />

    </div>
</template>

<script>
export default {
    name: 'idle',
    components: {
        // Async so a production screen never loads the navigator's chunk.
        DevNavigator: () => import('@/components/DevNavigator')
    },
    data() {
        return {
            animations: {
                logo: {
                    rotate: ['10deg', '0deg'],
                    opacity: [0, 1],
                    duration: 2000,
                    delay: 500
                }
            }
        };
    },
    computed: {
        showDevNavigator() {
            return (
                (process.env.NODE_ENV === 'development' ||
                    process.env.VUE_APP_SHOW_NAVIGATOR === 'true') &&
                !this.$route.query.loop
            );
        }
    }
};
</script>

<style lang="scss">
.sb_page_idle {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: url('~@/assets/bg-purple-pattern.png');
    background-size: cover;
    background-position: 50% 50%;
}

#pgf_logo {
    path {
        fill: $brand-white;
    }
}
#logo_curve-top {
    opacity: 0.4;
}
#logo_curve-bottom {
    opacity: 0.4;
}
</style>
